import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmpsCardComponentModule } from '@cmps/ng-kit';
import {
    CmpsButtonModule,
    CmpsIconModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCoachingInsightModule } from '../coaching-insight/coaching-insight.module';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';

import { CoachingCardRepComponent } from './coaching-card-rep.component';
import { TranslationIdMap } from './coaching-card-rep.i18n';
import { SortableHeaderDirective } from './helper/sortable-table-header.directive';

@NgModule({
    imports: [
        CommonModule,
        CmpsCommonModule,
        CmpsCardComponentModule,
        CmpsLazyI18nModule.forChild(TranslationIdMap),
        CmpsIconModule,
        CmpsButtonModule,
        CmpsTooltipModule,
        CmpsCoachingInsightModule,
    ],
    declarations: [CoachingCardRepComponent, SortableHeaderDirective],
    exports: [CoachingCardRepComponent],
})
export class CmpsCoachingCardRepModule {}
